const paths = <const>{
  home: '/',
  confirmBooking: '/confirm-booking',
  signIn: '/sign-in',
  signInWithLink: '/sign-in-with-link',
  activateAccount: '/activate-account',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  revertSecondFactor: '/revert-second-factor',
  security: '/security',
  legacyChangePassword: '/change-password',
  users: '/users',
  addUser: '/users/add',
  user: '/users/:id',
  profiles: '/profiles',
  addProfile: '/profiles/add',
  profile: '/profiles/:id',
  profileAccessCode: '/profiles/:profileId/access-code/:accessCodeId',
  profileUser: '/profiles/:profileId/users/:userId',
  resourceProfiles: '/resource-profiles',
  addResourceProfile: '/resource-profiles/add',
  resourceProfile: '/resource-profiles/:id',
  resources: '/resources',
  addResource: '/resources/add',
  resource: '/resources/:id',
  zones: '/zones',
  addZone: '/zones/add',
  zone: '/zones/:id',
  parkingSpots: '/booking/parking-spots',
  history: '/history',
  building: '/building/:id',
  buildings: '/buildings',
  tutorial: '/tutorial',
  news: '/news',
  addNewsfeedNotification: '/news/add',
  deleteAccount: '/delete-account',
  organizations: '/organizations',
  addOrganization: '/organizations/add',
  organization: '/organizations/:id',
  consents: '/consents',
  visitorCheckInRequests: '/visitor-check-in-requests',
  visitorCheckInRequest: '/visitor-check-in-requests/:id',
  visitorCheckInTargets: '/visitor-check-in-targets',
  lanMonitoring: '/lan-monitoring',
  lockDevices: '/lock-devices',
  lockDevice: '/lock-devices/:id',
  delegatedAccount: '/delegated-accounts/:id',
  locks: '/locks',
  lock: '/locks/:id',
  lockEdit: '/locks/:id/edit',
}

export default paths
